module.exports = __webpack_public_path__ + "img/home-icon.8c4b04f0.svg";